/** Pendant zu `Services/API/ApiConfigLaufzeitService.cs`. */

import type { ChinaAppSysLaufzeit } from '@/types/entities';

import { createCrudApi, type CrudApi } from '../apiBase';

export const laufzeitApi: CrudApi<ChinaAppSysLaufzeit> =
  createCrudApi<ChinaAppSysLaufzeit>('laufzeiten');
